import { render, staticRenderFns } from "./BadgeMessageCount.vue?vue&type=template&id=ece3b7de&"
import script from "./BadgeMessageCount.vue?vue&type=script&lang=js&"
export * from "./BadgeMessageCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports